/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { logDebug, logError } from '../mbpLog';

const logger = store => next => (action) => {
    const result = next(action);

    logDebug({
        action,
        'next-state': store.getState(),
        message: `REDUX: Dispatching Action: ${action.type}`,
    });

    return result;
};

const crashReporter = store => next => (action) => {
    try {
        return next(action);
    } catch (err) {
        logError({
            action,
            state: store.getState(),
            function: 'crashReporter',
            module: 'mbp-logger',
            jsError: err,
            message: 'Redux error',
        });

        throw err;
    }
};

export default {
    logger,
    crashReporter,
};
